import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/products/internal-agent')({
});

